import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Injector,
  Input,
  OnInit
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DevicesClass, DeviceTypes } from '@app/core/classes';
import {
  VenueCustomerProfileFieldsLayout,
  VENUE_FACILITY_OPTION_KEYS,
  VENUE_FACILITY_SUPPORT_LEVELS,
  venueFacilityLabel
} from './venue-customer-form.constants';

@Component({
  selector: 'app-venue-customer-facilities-fields',
  templateUrl: './venue-customer-facilities-fields.component.html',
  styleUrls: ['./venue-customer-facilities-fields.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VenueCustomerFacilitiesFieldsComponent extends DevicesClass implements OnInit {
  @Input() form!: FormGroup;
  @Input() layout: VenueCustomerProfileFieldsLayout = 'dialog';

  readonly DTypes = DeviceTypes;
  readonly FacilityOptionKeys = VENUE_FACILITY_OPTION_KEYS;
  readonly FacilitySupportLevels = VENUE_FACILITY_SUPPORT_LEVELS;

  facilitiesExpanded = false;

  constructor(injector: Injector, public cdr: ChangeDetectorRef) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.layout === 'signUp') {
      this.facilitiesExpanded = true;
    }
  }

  facilityLabel(key: string): string {
    return venueFacilityLabel(key);
  }

  facilityCommentLimit(key: string): number {
    const value = (this.form.get(`facility_${key}_notes`)?.value || '').toString();
    return 50 - value.length;
  }

  toggleFacilities(): void {
    this.facilitiesExpanded = !this.facilitiesExpanded;
    this.cdr.markForCheck();
  }
}
